import { render, staticRenderFns } from "./otherOrderDelivery.vue?vue&type=template&id=33aaa12a&scoped=true&"
import script from "./otherOrderDelivery.vue?vue&type=script&lang=js&"
export * from "./otherOrderDelivery.vue?vue&type=script&lang=js&"
import style0 from "./otherOrderDelivery.vue?vue&type=style&index=0&id=33aaa12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aaa12a",
  null
  
)

export default component.exports